// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.07 11.7L3.41 11.7C2.43 11.7 2 10.43 2.77 9.8C3.05 9.61 3.48 9.51 3.72 9.28C3.8 9.21 3.85 9.1 3.85 8.99L3.85 8.99C3.98 8.47 3.92 7.73 3.93 7.08M6.39 3.24C6.55 2.53 7.21 2 8 2C8.91 2 9.65 2.71 9.65 3.59L9.65 3.63C10.88 4.12 11.69 5.13 11.99 6.37C12.17 7.1 11.96 8.25 12.15 8.97L12.15 8.98C12.15 8.99 12.15 8.99 12.15 9M6.07 11.7L6.07 12C6.07 13.1 6.87 14 8.02 14C8.55 14 9 13.81 9.34 13.49M6.07 11.7L8.55 11.7',
  'M2 2L14 14',
];
